module.exports = __webpack_public_path__ + "img/nav-list.dd405b94.svg";